import { useMemo, useState } from 'react'
import { calcStroke } from './ggStrokePlay.js'
import { samplePlayers, netPlayers } from './ggSamplePlayers.js'

// G-StrokePlay — isolated sandbox. calcStroke ported from GolfGamesScorecard;
// net applied upstream (netPlayers). READ-ONLY over the in-code sample.
const Seg = ({ options, value, onChange }) => (
  <div className="flex items-center gap-1 rounded-lg p-1" style={{ backgroundColor: '#F3F4F6', border: '1px solid #E5E7EB' }}>
    {options.map((o) => {
      const on = value === o.value
      return (
        <button key={String(o.value)} onClick={() => onChange(o.value)}
          className="rounded-md px-3 py-1 text-xs font-bold uppercase tracking-wider transition"
          style={on ? { backgroundColor: '#1B4D2E', color: '#fff' } : { backgroundColor: 'transparent', color: '#374151' }}>
          {o.label}
        </button>
      )
    })}
  </div>
)
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }

export default function GStrokePlay() {
  const [net, setNet] = useState(false)
  const rows = useMemo(() => {
    const players = net ? netPlayers(samplePlayers()) : samplePlayers()
    return calcStroke(players)
  }, [net])

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-3">
        <Seg options={[{ value: false, label: 'Gross' }, { value: true, label: 'Net' }]} value={net} onChange={setNet} />
        <span className="text-sm text-gray-500">Lowest total wins.</span>
      </div>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>
          {['Pos', 'Player', 'Total'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}
        </tr></thead>
        <tbody>{rows.map((p, i) => (
          <tr key={p.id}><td style={cell}>{i + 1}</td><td style={cell}>{p.name}</td><td style={cell}><b>{p.total}</b></td></tr>
        ))}</tbody>
      </table>
    </div>
  )
}
